import {lazy} from '@aboutyou/lazy-imports';

export const SponsoredProductPopup = lazy(() =>
  import('./SponsoredProductPopup.eager').then(mod => ({
    default: mod.SponsoredProductPopup,
  })),
);
